import { ApiResult } from '@src/api/apiClient/apiResult';
import { axiosClient } from '@src/api/apiClient/axiosClient';
import { MediaTag } from '@src/api/types/mediaTag';
import { IndexRequest } from '@src/api/types/shared/request';

type MediaTagIndexResponse = MediaTag[];

export const mediaTagApiClient = {
  index: async (params: IndexRequest = {}): Promise<ApiResult<MediaTagIndexResponse>> => {
    return await axiosClient.get('/company/media-tags', { params });
  },
};
